export default "__VITE_ASSET__tIuBpXLf__"